<template>
  <div class="bgMesurement_ctn" :class="{ h82, isFromPumpReport }" :style="style">
    <div class="bgMesurement_descriptionRow bgMesurement_descriptionRow--top roundedCorner-t-l roundedCorner-t-r">
      <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50 roundedCorner-t-l roundedCorner-t-r">
        {{ $t('Number of BG measurements') }}
      </div>
      <!-- <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 roundedCorner-t-r"> -->
      <!--   <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--     <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Today') }}</span>         -->
      <!--     <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.bgPerDay }}</span> -->
      <!--   </div> -->
      <!--   <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--     <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Total') }}</span>         -->
      <!--     <span class="bgMesurement_descriptionRowContent--partOneContent">{{ bgTotal }}</span> -->
      <!--   </div>         -->
      <!-- </div> -->
    </div>
    <div class="bgMesurement_descriptionRow">
      <!-- <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50 roundedCorner-t-l"> -->
      <!--   {{ $t('Number of BG measurements') }} -->
      <!-- </div> -->
      <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 roundedCorner-t-r">
        <div class="bgMesurement_descriptionRowContent--part">
          <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Today') }}</span>        
          <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.bgPerDay }}</span>
        </div>
        <div class="bgMesurement_descriptionRowContent--part">
          <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Total') }}</span>        
          <span class="bgMesurement_descriptionRowContent--partOneContent">{{ bgTotal }}</span>
        </div>        
      </div>
    </div>    
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50">
        {{ isFromPumpReport ? $t('Glycemia Mean(for pump report)') : $t('Glycemia Mean') }}
      </div>    
    </div>
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine">
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('BG Mean') }}</span>
            <span class="bgMesurement_descriptionRowContent--partOneContent"></span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel"></span>
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.bgMean }}</span>
          </div>
        </div>
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('CGM Mean') }}</span>
            <span class="bgMesurement_descriptionRowContent--partOneContent"></span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel"></span>
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.cgmMean }}</span>
          </div>
        </div>        
      </div>
    </div>    
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50">
        {{ $t('Insulin Usage') }}
      </div>
      <!-- <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine"> -->
      <!--   <div class="bgMesurement_descriptionRow--contentOneCtn"> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Basal Rate') }}</span>         -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.insulinBasal | useThisInsteadIfEmpty }}</span> -->
      <!--     </div> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part bgMesurement_descriptionRowContent--partPlaceholder"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">-</span> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">-</span> -->
      <!--     </div> -->
      <!--   </div> -->
      <!--   <div class="bgMesurement_descriptionRow--contentOneCtn"> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Bolus') }}</span>         -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.insulinBolus | useThisInsteadIfEmpty }}</span> -->
      <!--     </div> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part bgMesurement_descriptionRowContent--partPlaceholder"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">-</span> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">-</span> -->
      <!--     </div> -->
      <!--   </div> -->
      <!--   <div class="bgMesurement_descriptionRow--contentOneCtn"> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Total') }}</span>         -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.insulinTotal | useThisInsteadIfEmpty }}</span> -->
      <!--     </div> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part bgMesurement_descriptionRowContent--partPlaceholder"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">-</span> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">-</span> -->
      <!--     </div> -->
      <!--   </div> -->
      <!-- </div> -->
    </div>
    <div class="bgMesurement_descriptionRow">
      <!-- <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50"> -->
      <!--   {{ $t('Insulin Usage') }} -->
      <!-- </div> -->
      <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine">
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Basal Rate') }}</span>
            <span class="bgMesurement_descriptionRowContent--partOneContent"></span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel"></span>
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.insulinBasal | useThisInsteadIfEmpty }}</span>
          </div>
        </div>
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Bolus') }}</span>
            <span class="bgMesurement_descriptionRowContent--partOneContent"></span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel"></span>
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.insulinBolus | useThisInsteadIfEmpty }}</span>
          </div>
        </div>
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Total') }}</span>
            <span class="bgMesurement_descriptionRowContent--partOneContent"></span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel"></span>
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.insulinTotal | useThisInsteadIfEmpty }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bgMesurement_descriptionRow">
      <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50">
        {{ isFromPumpReport ? $t('Carbonhydrate Amount [g]') : $t('Carbonhydrate Total') }}
      </div>
      <!-- <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine"> -->
      <!--   <div class="bgMesurement_descriptionRow--contentOneCtn"> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Today') }}</span>         -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.carbohydrTotal }}<span style="margin-left: 0.3em;">[g]</span></span> -->
      <!--     </div> -->
      <!--     <div class="bgMesurement_descriptionRowContent--part"> -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Total') }}</span>         -->
      <!--       <span class="bgMesurement_descriptionRowContent--partOneContent">{{ carbonMultidayTotal }}<span style="margin-left: 0.3em;">[g]</span></span> -->
      <!--     </div> -->
      <!--   </div> -->
      <!-- </div> -->
    </div>
    <div class="bgMesurement_descriptionRow">
      <!-- <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50"> -->
      <!--   {{ isFromPumpReport ? $t('Carbonhydrate Amount [g]') : $t('Carbonhydrate Total') }} -->
      <!-- </div> -->
      <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine">
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Today') }}</span>        
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.carbohydrTotal }}<span style="margin-left: 0.3em;">[g]</span></span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Total') }}</span>        
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ carbonMultidayTotal }}<span style="margin-left: 0.3em;">[g]</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="bgMesurement_descriptionRow bgMesurement_descriptionRow--noTitle">
      <div class="bgMesurement_descriptionRow--label bgMesurement_descriptionRow--label50">
        {{ $t('Boluses Calculator Usage') }}
      </div>
    </div>
    <div class="bgMesurement_descriptionRow bgMesurement_descriptionRow--noTitle roundedCorner-b-l roundedCorner-b-r">
      <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine">
        <div class="bgMesurement_descriptionRow--contentOneCtn">
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('With') }}</span>        
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.calculatorBolusPercent }}%</span>
          </div>
          <div class="bgMesurement_descriptionRowContent--part">
            <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Without') }}</span>        
            <span class="bgMesurement_descriptionRowContent--partOneContent">{{ value.disagreePercent }}%</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bgMesurement_descriptionRow bgMesurement_descriptionRow--noTitle roundedCorner-b-l roundedCorner-b-r"> -->
    <!--   <div class="bgMesurement_descriptionRow--content bgMesurement_descriptionRow--content50 bgMesurement_descriptionRow--contentHorizontalOneLine roundedCorner-b-r"> -->
    <!--     <div class="bgMesurement_descriptionRow--contentOneCtn"> -->
    <!--       <div class="bgMesurement_descriptionRowContent--part"> -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('With') }}</span>         -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneContent"></span> -->
    <!--       </div> -->
    <!--       <div class="bgMesurement_descriptionRowContent--part"> -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ value.calculatorBolusPercent }}%</span> -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneContent"></span> -->
    <!--       </div> -->
    <!--     </div> -->
    <!--     <div class="bgMesurement_descriptionRow--contentOneCtn"> -->
    <!--       <div class="bgMesurement_descriptionRowContent--part"> -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ $t('Without') }}</span>         -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneContent"></span> -->
    <!--       </div> -->
    <!--       <div class="bgMesurement_descriptionRowContent--part"> -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneLabel">{{ value.disagreePercent }}%</span> -->
    <!--         <span class="bgMesurement_descriptionRowContent--partOneContent"></span> -->
    <!--       </div> -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

export default {
  name: 'CTableBGMesurementV3',
  mixins: [reDrawTrigger],
  props: {
    isDaily: {
      type: [Boolean],
      default: false
    },
    dailyTotal: {
      type: [Number, String],
      default: ''
    },
    carbonTotal: {
      type: [Number, String],
      default: ''
    },
    h82: {
      type: [Boolean, String, Number],
      default: false
    },
    width: {
      type: [String, Number],
      default: 455
    },
    value: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    return {      
    }
  },
  computed: {
    style() {
      const { zoom, isDaily, width } = this
      const rst = { zoom, marginTop: (isDaily ? '0px' : `35px`), width: `${width}px`, fontSize: 20 + 'px' }
      return rst
    },
    isFromPumpReport() {
      const { h82 } = this
      return !!h82
    },
    bgTotal() {
      const { isDaily, dailyTotal, value = {}} = this
      return isDaily ? dailyTotal : value.bgTotal
    },
    carbonMultidayTotal() {
      // 这里逻辑好像不对，isDaily如果为true，应该访问value.carbohydrTotal;但我懒得改了，所以就负负得正，就对了
      const { isDaily, carbonTotal, value = {}} = this
      const rst = isDaily ? carbonTotal : value.carbohydrTotal
      return !rst ? 0 : rst
    },
    zoom() {
      const { zoomRatio = 1, width, body21CmRatio = 1200 } = this
      const limit = Math.max(Math.ceil(body21CmRatio / 2), 780)
      if (width - limit <= 0) {
        // return zoomRatio * 0.8
        return zoomRatio
      } else {
        return zoomRatio
      }
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

/* $rowH: 430px; */
$rowH: 43px;
$rowH2: $rowH;
.bgMesurement_ctn {
    color: $colorGluMesurementFont;
    /* font-weight: 600; */
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;
    .bgMesurement_titleRow {
        /* @include heightMiddle($rowH); */
        min-height: $rowH;
        @include bBox;
        @include flexRow(flex-start, center);
    }
    &.h82 .bgMesurement_titleRow {
        /* @include heightMiddle($rowH2); */
        min-height: $rowH2;
    }
    .bgMesurement_titleRow, .bgMesurement_descriptionRow {        
        @include bBox;
        /* height: 44px; */
        /* overflow: hidden; */
        /* min-height: 44px; */
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.bgMesurement_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.bgMesurement_titleRow--top, &.bgMesurement_descriptionRow--top {
            /* text-indent: 20px; */
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    &.h82 .bgMesurement_descriptionRow .bgMesurement_descriptionRow--label, .bgMesurement_descriptionRow--content {
        min-height: $rowH2;
        text-indent: 0;
    }
    .bgMesurement_descriptionRow {
        @include flexRow(space-evenly, stretch);
        .bgMesurement_descriptionRow--label, .bgMesurement_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            /* height: 100%; */
            min-height: $rowH;
            width: 25%;
            @include flexColumn(center, flex-start);
        }
        .bgMesurement_descriptionRow--content {
            /* align-items: center; */
            @include flexRow(space-between, center);
            padding: 0 0.5rem;
            .bgMesurement_descriptionRow--contentOneCtn {
                @include bBox;
                display: inline-block;
                min-width: 48%;
                flex-grow: 1;                
                flex-shrink: 1;
                height: $rowH;
                @include flexRow(space-between, center);
                .bgMesurement_descriptionRow--contentOneCtnTitle {
                    width: 50%;
                    text-align: left;
                    flex-grow: 1;
                    flex-shrink: 1;
                }
                .bgMesurement_descriptionRow--contentOneCtnValue {
                    width: 50%;
                    text-align: center;
                    flex-grow: 1;
                    flex-shrink: 1;
                }
            }
            &.bgMesurement_descriptionRow--content50 {
                width: 50%;
                flex-grow: 1;
                &.bgMesurement_descriptionRow--contentHorizontalOneLine {
                    padding: 0 0;
                    @include flexColumn(center, flex-start);
                    .bgMesurement_descriptionRow--contentOneCtn {
                        @include bBox;
                        width: 100%;
                        padding: 0.3rem 0.5rem;
                        border-bottom-width: 1px;
                        border-bottom-color: $colorGluMesurementInnerBorder;
                        border-bottom-style: solid;
                        &:last-child {
                            border-bottom: 0;
                        }
                        &:only-child {
                            border-bottom: 0;
                        }
                        .bgMesurement_descriptionRow--contentOneCtnTitle {
                            text-align: left;
                            width: auto;
                        }
                        .bgMesurement_descriptionRow--contentOneCtnValue {
                            text-align: left;
                        }
                        /* border: 1px solid red; */
                    }
                }
            }
            .bgMesurement_descriptionRowContent--part {
                width: 50%;
                flex-grow: 1;
                flex-shrink: 1;
                display: flex;
                > .bgMesurement_descriptionRowContent--partOneLabel, > .bgMesurement_descriptionRowContent--partOneContent {
                    flex-grow: 1;
                    flex-shrink: 1;                    
                }
                > .bgMesurement_descriptionRowContent--partOneLabel {
                    text-align: left;
                }
                > .bgMesurement_descriptionRowContent--partOneContent {
                    text-align: right;
                }
                &.bgMesurement_descriptionRowContent--partPlaceholder {
                    opacity: 0;
                }
                &:first-child {
                    margin-right: 5px;
                }
                &:last-child {
                    margin-left: 5px;
                }
            }
        }
        .bgMesurement_descriptionRow--content{
            /* font-size: 0.8em; */
            font-size: 0.9em;
        }
        .bgMesurement_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;
            
            &.bgMesurement_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.bgMesurement_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
    }
    
    &.isFromPumpReport {
        .bgMesurement_descriptionRow--label {
            width: 60%;
            &.bgMesurement_descriptionRow--label4 {
                width: 100%;
            }
            &.bgMesurement_descriptionRow--label50 {
                width: 50%;
                flex-shrink: 1;
            }
        }
    }
}
</style>
